export default __webpack_public_path__ + "static/media/sample_pdf.e6ffa4eb.pdf";